import Button from "app/components/Button";
import Modal from "app/components/Modal";
import React from "react";
interface Props {
  setDeleteDraft: (val: boolean) => void;
  handleRemoveDraft: () => void;
  onClose: () => void;
  setDraftId: (val: any) => void;
}

const DraftModal: React.FC<Props> = ({
  setDeleteDraft,
  handleRemoveDraft,
  onClose,
  setDraftId,
}) => {
  return (
    <>
      <Modal
        onClose={() => setDeleteDraft(false)}
        title="Save draft?"
        modalClassName="flex flex-col items-center p-0 gap-6 absolute w-[400px] h-[203px] left-[50%] top-[50%] transform -translate-x-1/2 -translate-y-1/2 bg-white border border-[#E9ECF2] rounded-lg"
        optionalFooterClass="bg-[#F4F5F7] rounded-b-md px-6 py-4"
        renderModalFooter={
          <div className="flex justify-end gap-3">
            <Button
              className="!bg-[transparent] !text-[#EB5757] border border-[#EB5757] rounded  h-9 text-sm font-medium"
              onClick={() => handleRemoveDraft()}
            >
              Delete draft
            </Button>
            <Button
              className="text-sm font-medium rounded bg-primary text-white"
              onClick={() => {
                setDeleteDraft(false);
                onClose();
                setDraftId(null);
              }}
            >
              Save draft
            </Button>
          </div>
        }
      >
        <p className="text-left text-[#79808A]">
          Would you like to save a draft of this task? It can be accessed within
          your task tray.
        </p>
      </Modal>
    </>
  );
};

export default DraftModal;
